import { Pipe, PipeTransform, inject } from '@angular/core';

import { IndustryModel } from '~app/models/industry.model';
import { LicenseListModel } from '~app/models/responses/license-list.model';
import { UserListModel } from '~app/models/responses/user-list.model';
import { IndustriesStore } from '~app/services/stores/industries.store';
import { LicensesStore } from '~app/services/stores/licenses.store';
import { ResellersStore } from '~app/services/stores/resellers.store';
import { UsersStore } from '~app/services/stores/users.store';
import { DialogModelFactoryService } from '~components/dialogs/data-selection-dialog/data-selection-table-configs/dialog-model-factory.service';
import { QuickSearchConfigModel } from '~components/form/quick-search/models/quick-search-config.model';
import { ComplexDataTypesEnum } from '~core/models/complex-data-types.enum';

@Pipe({ name: 'arcQuickSearchConfig' })
export class QuickSearchConfigPipe implements PipeTransform {
    private readonly licensesStore = inject(LicensesStore);
    private readonly usersStore = inject(UsersStore);
    private readonly resellersStore = inject(ResellersStore);
    private readonly industriesStore = inject(IndustriesStore);
    private readonly dialogModelFactory = inject(DialogModelFactoryService);

    transform(complexDataType: ComplexDataTypesEnum, shouldHideDataSelectDialogButton = false): QuickSearchConfigModel<any> {
        switch (complexDataType) {
            case ComplexDataTypesEnum.License:
                return new QuickSearchConfigModel<LicenseListModel>({
                    store: this.licensesStore,
                    labelDisplayFn: license => license?.licenseHolder ?? '',
                    shouldHideDataSelectDialogButton,
                    dataSelectionDialogConfig: this.dialogModelFactory.create(ComplexDataTypesEnum.License)
                });
            case ComplexDataTypesEnum.User:
                return new QuickSearchConfigModel<UserListModel>({
                    store: this.usersStore,
                    labelDisplayFn: user => this.getUserDisplayname(user),
                    shouldHideDataSelectDialogButton,
                    dataSelectionDialogConfig: this.dialogModelFactory.create(ComplexDataTypesEnum.User)
                });
            case ComplexDataTypesEnum.Reseller:
                return new QuickSearchConfigModel<UserListModel>({
                    store: this.resellersStore,
                    labelDisplayFn: reseller => reseller?.company ?? '',
                    shouldHideDataSelectDialogButton,
                    dataSelectionDialogConfig: this.dialogModelFactory.create(ComplexDataTypesEnum.Reseller)
                });
            case ComplexDataTypesEnum.Industry:
                return new QuickSearchConfigModel<IndustryModel>({
                    store: this.industriesStore,
                    labelDisplayFn: industry => industry?.title ?? '',
                    shouldHideDataSelectDialogButton,
                    dataSelectionDialogConfig: this.dialogModelFactory.create(ComplexDataTypesEnum.Industry)
                });
        }
    }

    private getUserDisplayname(user?: UserListModel): string {
        if (!user) {
            return '';
        }

        if (!!user.company) {
            return `${user.company} - ${user.userName}`;
        }

        return user.userName;
    }
}
